import React from 'react';
import { Icon } from 'iovisit-theme/components';
import config from '@plone/volto/registry';

const HeaderTopLink = () => (
  <div className="iv--header-top-link">
    {config.settings.iovisit.topLink?.text &&
      config.settings.iovisit.topLink?.url && (
        <a
          href={config.settings.iovisit.topLink.url}
          className="iv--header-top-externallink"
          rel="noopener noreferrer"
          target="_blank"
        >
          <Icon prefix="fas" icon="external-link-alt" className="icon" />
          <span>{config.settings.iovisit.topLink.text}</span>
        </a>
      )}
  </div>
);

export default HeaderTopLink;
